import React from "react";
import { View } from "react-native";
// import {Modal} from "react-native"
import Modal from "./../components/WebModal";
import CustomIcon from "./CustomIcon";

function CustomModal({
  visible,
  style = {},
  closable = false,
  onClose = () => {},
  children,
}) {
  return (
    <Modal
      visible={visible}
      statusBarTranslucent={true}
      animationType="fade"
      transparent
    >
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          backgroundColor: "#00000050",
        }}
      >
        <View
          style={[
            {
              minHeight: "40%",
              width: "95%",
              backgroundColor: "#ffffff",
              padding: 15,
            },
            style,
          ]}
        >
          {closable ? (
            <CustomIcon
              type="AntDesign"
              name="close"
              style={{ position: "absolute", right: 10, top: 10, zIndex: 1 }}
              onPress={onClose}
            />
          ) : null}
          {children}
        </View>
      </View>
    </Modal>
  );
}

export default CustomModal;
